import { createPostEndpoint, getQueryString, HttpHeader } from '@sonar-software/sonar-http';

export type PostStartSalesforceImportRequest = {
	organizationId?: number;
	shardName?: string;
	forceFullRefresh?: boolean;
};

export type PostStartSalesforceImportResponse = {
	id: number;
};

export const postStartSalesforceImport = createPostEndpoint<
	PostStartSalesforceImportRequest,
	PostStartSalesforceImportResponse
>(
	(request) =>
		`/api/v3/core/imports/salesforce/start/${request?.organizationId || ''}?${getQueryString({
			forceFullRefresh: request?.forceFullRefresh
		})}`,
	{
		headers: (request) => {
			if (request?.shardName) {
				return { [ HttpHeader.Shard ]: request.shardName };
			}

			return {};
		}
	}
);
